import Component from '@glimmer/component';

interface LoadingSpinnerSignature {
  Args: {
    size?: 'small' | 'medium' | 'large';
    text?: string;
    centered?: boolean;
  };
  Element: HTMLDivElement;
}

export default class LoadingSpinner extends Component<LoadingSpinnerSignature> {
  get sizeClass() {
    const size = this.args.size || 'medium';
    return `loading-spinner--${size}`;
  }

  get wrapperClass() {
    const classes = ['loading-spinner'];
    classes.push(this.sizeClass);
    if (this.args.centered) {
      classes.push('loading-spinner--centered');
    }
    return classes.join(' ');
  }

  <template>
{{!--    <div class={{this.wrapperClass}} ...attributes role="status" aria-live="polite">--}}
{{!--      <div class="loading-spinner__icon" aria-hidden="true">--}}
{{!--        <svg class="spinner-svg" viewBox="0 0 50 50">--}}
{{!--          <circle class="path" cx="25" cy="25" r="20" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10"/>--}}
{{!--        </svg>--}}
{{!--      </div>--}}
{{!--      {{#if @text}}-->
<!--        <p class="loading-spinner__text">{{@text}}</p>-->
<!--      {{else}}-->
<!--        <p class="loading-spinner__text sr-only">Loading...</p>-->
<!--      {{/if}}--}}
{{!--    </div>--}}

    <style>
      .loading-spinner {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 8px;
      }

      .loading-spinner--centered {
        justify-content: center;
        min-height: 200px;
      }

      .loading-spinner__icon {
        display: inline-block;
      }

      .loading-spinner--small .spinner-svg {
        width: 20px;
        height: 20px;
      }

      .loading-spinner--medium .spinner-svg {
        width: 32px;
        height: 32px;
      }

      .loading-spinner--large .spinner-svg {
        width: 48px;
        height: 48px;
      }

      .spinner-svg {
        animation: rotate 2s linear infinite;
        color: #7c3aed; /* Gaming purple theme */
      }

      .path {
        stroke-linecap: round;
        animation: dash 1.5s ease-in-out infinite;
      }

      .loading-spinner__text {
        font-size: 14px;
        color: #9ca3af;
        margin: 0;
      }

      .sr-only {
        position: absolute;
        width: 1px;
        height: 1px;
        padding: 0;
        margin: -1px;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        white-space: nowrap;
        border: 0;
      }

      @keyframes rotate {
        100% {
          transform: rotate(360deg);
        }
      }

      @keyframes dash {
        0% {
          stroke-dasharray: 1, 150;
          stroke-dashoffset: 0;
        }
        50% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -35;
        }
        100% {
          stroke-dasharray: 90, 150;
          stroke-dashoffset: -124;
        }
      }
    </style>
  </template>
}
